Number.prototype.roundNumber = function (scale) {
  var num = this;

  if (!("" + num).includes("e")) {
    if (num < 0)
      return parseFloat(num.toFixed(scale));
    else
      return +(Math.round(num + "e+" + scale) + "e-" + scale);

  } else {
    var arr = ("" + num).split("e");
    var sig = "";
    if (+arr[1] + scale > 0) {
      sig = "+";
    }
    return +(
      Math.round(+arr[0] + "e" + sig + (+arr[1] + scale)) +
      "e-" +
      scale
    );
  }
};

Number.prototype.nth = function () {
  var d = this;
  if (d > 3 && d < 21) return "th";
  switch (d % 10) {
    case 1:
      return "st";
    case 2:
      return "nd";
    case 3:
      return "rd";
    default:
      return "th";
  }
};

Number.prototype.numberWithCommas = function () {
  var n = this;
  var parts = n.toString().split(".");
  return (
    parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ",") +
    (parts[1] ? "." + parts[1] : "")
  );
};

Number.prototype.isFloat = function () {
  return Number(this) === this && this % 1 !== 0;
}

Number.prototype.round2Decimal = function () {
  return Math.round(this * 100) / 100;
}
